import React from "react";
import { MapPin } from "./icons";
import { LocationPicker } from "./LocationPicker";
import { ErrorBoundary } from "@/components/ErrorBoundary";

/**
 * DifferentPickupSection — opt-in split-location wrapper. When collapsed, a
 * single "+ Pickup from a different location?" prompt. When expanded, a
 * mini LocationPicker with a Remove button that resets the pickup state.
 * The customer sees this only after the delivery destination is set.
 */
export const DifferentPickupSection = ({
  differentPickup,
  onToggle,
  onRemove,
  pickupState,
  setPickupIsOffProperty,
  setPickupZoneId,
  setPickupResort,
  setPickupAddress,
  setPickupAddrCheck,
  zones,
}) => {
  if (!differentPickup) {
    return (
      <div className="mt-4" data-testid="different-pickup-toggle-wrap">
        <button
          type="button"
          onClick={onToggle}
          className="text-xs text-[#FFD166] hover:underline inline-flex items-center gap-1"
          data-testid="different-pickup-toggle"
        >
          + Pickup from a different location? (e.g. checked-in Disney Springs, checking-out from a Disney resort)
        </button>
      </div>
    );
  }

  return (
    <div className="mt-4" data-testid="different-pickup-toggle-wrap">
      <div className="pt-4 border-t border-[#FFD166]/10" data-testid="different-pickup-section">
        <div className="flex items-center justify-between mb-3">
          <label className="eyebrow flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5 text-[#FFD166]" /> Different pickup location
          </label>
          <button
            type="button"
            onClick={onRemove}
            className="text-[11px] text-[#B9C8D5] hover:text-[#F4A93A]"
            data-testid="different-pickup-remove"
          >
            Remove
          </button>
        </div>
        <p className="text-[11px] text-[#B9C8D5] mb-3">
          We&rsquo;ll <b className="text-[#FFD166]">deliver</b> to the address above and <b className="text-[#FFD166]">pick up</b> from the location you choose here.
        </p>
        <ErrorBoundary name="pickup-address" title="We hit a snag checking that address." message="Try selecting an address from the dropdown suggestions.">
        <LocationPicker
          state={pickupState}
          setIsOffProperty={setPickupIsOffProperty}
          setZoneId={setPickupZoneId}
          setResort={setPickupResort}
          setAddress={setPickupAddress}
          setAddrCheck={setPickupAddrCheck}
          zones={zones}
          testidPrefix="different-pickup"
          verb="pick up"
          labels={{
            disneyPlaceholder: "Pick your Disney pickup resort…",
            areaPlaceholder: "Choose your pickup area…",
            addressPlaceholder: "Full pickup address (street, city, state, ZIP)",
            offsiteResortPlaceholder: "Pick your pickup resort…",
            successAddress: "✓ Great — we pick up from here!",
            failAddress: "We don't pick up from that address.",
          }}
        />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default DifferentPickupSection;
